import React from 'react';
import BodyText from '../../Text/BodyText/BodyText';
import { withStyles } from '../../../utils/utils';
import styles from './DetailRows.module.scss';

const cn = withStyles(styles);

export interface DetailRow {
  label: React.ReactNode;
  value: React.ReactNode;
  visible?: boolean;
}

export interface DetailRowsProps {
  details: DetailRow[];
  className?: string;
  rowSeparators?: boolean;
}

export default function DetailRows({ details, className, rowSeparators = true }: DetailRowsProps) {
  const visibleDetails = details.filter(({ visible = true }) => visible);

  if (visibleDetails.length === 0) {
    return null;
  }

  return (
    <div className={cn('detailsContainer', className)} data-testid="detail-rows">
      {visibleDetails.map((detail, index) => (
        <div key={index} className={cn('detailRow', !rowSeparators && 'noRowSeparator')}>
          <BodyText weight="md">{detail.label}</BodyText>
          <BodyText className={cn('detailValue')}>{detail.value}</BodyText>
        </div>
      ))}
    </div>
  );
}
